import * as React from "react"
import { Typography } from '@mui/material'
import {formatPrice} from "@ui-seeker/utils";


export default function pvpColumn() {
return {
		name: 'PVP',
		label: 'PVP',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ textAlign: 'center' }}>
				{formatPrice(value, 'EUR')}
			</Typography>
		}
	}
}